/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AlertEditableFormComponent} from './alert-editable-form.component';
import {InputModule} from '../../../../shared/input/input.module';
import {ToggleButtonModule} from '../../../../shared/toggle-button/toggle-button.module';
import {SwitchButtonModule} from '../../../../shared/switch-button/switch-button.module';
import {TooltipModule} from '../../../../shared/tooltip/tooltip.module';

@NgModule({
    declarations: [AlertEditableFormComponent],
    exports: [AlertEditableFormComponent],
    imports: [
        CommonModule,
        InputModule,
        ToggleButtonModule,
        SwitchButtonModule,
        TooltipModule
    ]
})
export class AlertEditableFormModule {
}
